<div class="container">
  <div class="card flex-center">
    <h2 class="title">Thank you!</h2>
    <div class="description">This payment has already been completed.</div>
  </div>
</div>

<style>
  .container {
    font-family: var(--font-family), sans-serif;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }

  .card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 20rem;
    min-height: 16rem;
    background-color: var(--main-white-color);
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    color: var(--toonie-primary-color);
  }

  .title {
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 0.6rem;
  }

  .flex-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .description {
    font-size: 18px;
    margin-bottom: 20px;
    text-align: center;
  }
</style>
